/* eslint-disable react/no-array-index-key */
import { createUseStyles } from "react-jss";
import DeleteBin2LineIcon from "remixicon-react/DeleteBin2LineIcon";
import { Button as UIButton } from "@mui/material";
import Text from "$components/Text";
import { theme } from "$utils/theme/bataillog";

function FileItem({ value, onRemoveFile, isAdmin, disabled = false }: any) {
  const { name, percentage, state, url, isToRemove } = value;
  const classes = useStyles();

  if (isToRemove) return <div style={{ width: 0 }} />;

  return (
    <div className={classes.fileItem}>
      <div className={classes.fileName}>
        {url ? (
          <a href={`${url}`} target="_blank" rel="noreferrer">
            {name}
          </a>
        ) : (
          <p>{name}</p>
        )}
      </div>
      <div className={classes.fileActions}>
        {state === "pending" && (
          <div className={classes.fileProgressBar}>
            <div
              className={classes.fileProgress}
              style={{ width: `${percentage}%` }}
            />
          </div>
        )}
        {state !== "pending" && isAdmin && !disabled && (
          <div className={classes.fileDelete}>
            <UIButton
              variant="text"
              style={{ textTransform: "none", minWidth: 30 }}
              onClick={onRemoveFile(value)}
            >
              <DeleteBin2LineIcon />
            </UIButton>
          </div>
        )}
      </div>
    </div>
  );
}

function FileList({
  items,
  onRemoveFile,
  isAdmin,
  isSplitted,
  mainLabel,
  mainEmptyLabel,
  secondaryLabel,
  secondaryItems,
  secondaryEmptyLabel,
}: any) {
  const classes = useStyles();
  const ritems = [...items].reverse();

  if (isSplitted) {
    return (
      <div className={classes.fileList}>
        <p>{mainLabel}</p>
        {ritems.length > 0 ? (
          ritems.map((value: any, index: number) => (
            <FileItem
              key={`item-${index}`}
              index={index}
              value={value.attributes || value}
              onRemoveFile={onRemoveFile}
              isAdmin={isAdmin}
            />
          ))
        ) : (
          <p style={{ textAlign: "center" }}>{mainEmptyLabel}</p>
        )}
        {secondaryItems.length > 0 && (
          <div
            style={{
              height: 1,
              margin: "10px 15px",
              backgroundColor: "#DFE1E6",
            }}
          />
        )}
        {secondaryItems.length > 0 && <p>{secondaryLabel}</p>}
        {secondaryItems.map((item: any, index: number) => (
          <div key={index}>
            <p>{`${item.reference} :`}</p>
            {item?.files?.length > 0 ? (
              item?.files?.map((file: any, index: any) => (
                <FileItem
                  key={`subItem-${index}`}
                  index={index}
                  value={file.attributes || file}
                  onRemoveFile={onRemoveFile}
                  isAdmin={isAdmin}
                  disabled
                />
              ))
            ) : (
              <p style={{ textAlign: "center" }}>{secondaryEmptyLabel}</p>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={classes.fileList}>
      {ritems?.length > 0 ? (
        ritems.map((value: any, index: number) => (
          <FileItem
            key={`item-${index}`}
            index={index}
            value={value}
            onRemoveFile={onRemoveFile}
            isAdmin={isAdmin}
          />
        ))
      ) : (
        <Text className={classes.noFilePlaceholder}>Aucun fichier</Text>
      )}
    </div>
  );
}

function FilesList(props: any) {
  return <FileList {...props} />;
}

FilesList.defaultProps = {
  items: [],
  onRemoveFile() {},
  isAdmin: false,
};

const useStyles = createUseStyles(() => ({
  fileList: {
    paddingLeft: 10,
    flex: 1,
  },
  fileItem: {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    padding: 5,
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
  fileActions: {
    position: "relative",
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
  },
  fileName: {
    lineHeight: "34px",
    flex: 3,
    "& a": {
      color: "#2d2d2d",
    },
  },
  fileDelete: {},
  fileProgressBar: {
    height: ".5rem",
    backgroundColor: "grey",
    borderRadius: 5,
    position: "absolute",
    width: "90%",
    left: 0,
    right: 0,
    margin: "0 auto",
    bottom: 12,
  },
  fileProgress: {
    backgroundColor: "blue",
    height: "100%",
    margin: 0,
    borderRadius: 5,
  },
  noFilePlaceholder: {
    display: "block",
    marginTop: `${theme.spacing(2)}px`,
    fontStyle: "italic",
  },
}));

export default FilesList;
